import AppStore from "./app-store";
// import BeetStore from "../../src/models/Beets/beet-store";
// import BerryStore from "../../src/models/Berries/berry-store";

const store = {
  app: new AppStore()
  // beet: new BeetStore(),
  // berry: new BerryStore()
};

export default store;



// WEBPACK FOOTER //
// ./src/stores/index.js